import request from '@/utils/request'

// 取得專家列表
export const getExpertMap = ({ lotteryCode: cpCode }) => {
  const url = `/v1/public/expert`

  return request({
    url,
    params: { cpCode }
  })
}
